import { render, staticRenderFns } from "./HeaderMainMenu.vue?vue&type=template&id=71355985&"
import script from "./HeaderMainMenu.vue?vue&type=script&lang=js&"
export * from "./HeaderMainMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports